import { useRecoilState } from 'recoil';
import userManual from '../assets/icons/user_manual.png';
import techManual from '../assets/icons/technician_manual.png';
import faq from '../assets/icons/faq.png';
import navHeaderAtom from '../atoms/navHeaderAtom';
import { useEffect } from 'react';
import ManualCard from './ManualCard';
import { containerOne } from '../utils/style';

function ManualList() {
    const [ header, setHeader ] = useRecoilState(navHeaderAtom);


    useEffect(() => {
        setHeader('Manuals')
    }, [])

    return(
        <div className={containerOne}>
            <ManualCard image={userManual} title={'User Manual'} type='user_manuals'/>
            <ManualCard image={techManual} title={'Technician Manual'} type='technician_manuals'/>
            <ManualCard image={faq} title={'FAQs/Queries'} type='faq'/>
        </div>
    )
}

export default ManualList;